import { createStateSelectorHook } from 'src/lib/sweetState';

import { LocalStore } from '../../store';

const useLocalState = createStateSelectorHook(LocalStore, [
  'multiPromptFields',
  'generationTool',
  'generating',
  'messagingBank',
  'isUploadingImage',
  'isUploadingDocument',
  'multiPromptFieldImages',
  'multiPromptFieldDocuments',
  'uploadingDocuments',
  'uploadingImages',
  'currentUrls',
  'uploadedCsv',
  'isCsvLoading',
  'language',
]);

export const useViewState = () => {
  const {
    multiPromptFields,
    generationTool,
    generating,
    isUploadingImage,
    isUploadingDocument,
    multiPromptFieldImages,
    multiPromptFieldDocuments,
    uploadingDocuments,
    uploadingImages,
    currentUrls,
    uploadedCsv,
    isCsvLoading,
    language,
  } = useLocalState();

  return {
    multiPromptFields,
    generationTool,
    generating,
    isUploadingImage,
    isUploadingDocument,
    multiPromptFieldImages,
    multiPromptFieldDocuments,
    uploadingDocuments,
    uploadingImages,
    currentUrls,
    uploadedCsv,
    isCsvLoading,
    language,
  };
};
